'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M6 22h12l-6-6zM21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V5h18v12h-4v2h4c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' });

var Airplay = function Airplay(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Airplay = (0, _pure2.default)(Airplay);
Airplay.muiName = 'SvgIcon';

exports.default = Airplay;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/Airplay.js
// module id = 2110
// module chunks = 0